import { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, FileText, Shield, Lock, Award, Scale, Building2, Briefcase, AlertTriangle, Users } from 'lucide-react';

const COLORS = {
  primary: '#21A038',
  primaryDark: '#1A8F2D',
  dark: '#0f172a',
  gray: '#64748b',
  grayLight: '#94a3b8',
  white: '#ffffff',
  bg: '#f8fafc'
};

const documents = [
  {
    id: 'license-broker',
    title: 'Лицензия на брокерскую деятельность',
    icon: <Award size={24} />,
    content: `
ЛИЦЕНЗИЯ № 159
на осуществление брокерской деятельности на рынке ценных бумаг

Настоящая лицензия выдана:
ОсОО «ФВА Финанс»

Дата выдачи: 16 марта 2017 года
Срок действия: бессрочная

Вид деятельности:
- Брокерская деятельность на рынке ценных бумаг

Лицензирующий орган:
ГОСУДАРСТВЕННАЯ СЛУЖБА РЕГУЛИРОВАНИЯ И НАДЗОРА 
ЗА ФИНАНСОВЫМ РЫНКОМ ПРИ ПРАВИТЕЛЬСТВЕ КЫРГЫЗСКОЙ РЕСПУБЛИКИ

Условия осуществления деятельности:
1. Соблюдение требований законодательства Кыргызской Республики
2. Соблюдение требований по защите прав инвесторов
3. Ведение учёта и отчётности в установленном порядке

М.П.
    `
  },
  {
    id: 'license-dealer',
    title: 'Лицензия на дилерскую деятельность',
    icon: <Award size={24} />,
    content: `
ЛИЦЕНЗИЯ № 160
на осуществление дилерской деятельности на рынке ценных бумаг

Настоящая лицензия выдана:
ОсОО «ФВА Финанс»

Дата выдачи: 16 марта 2017 года
Срок действия: бессрочная

Вид деятельности:
- Дилерская деятельность на рынке ценных бумаг

Лицензирующий орган:
ГОСУДАРСТВЕННАЯ СЛУЖБА РЕГУЛИРОВАНИЯ И НАДЗОРА 
ЗА ФИНАНСОВЫМ РЫНКОМ ПРИ ПРАВИТЕЛЬСТВЕ КЫРГЫЗСКОЙ РЕСПУБЛИКИ

Условия осуществления деятельности:
1. Соблюдение требований законодательства Кыргызской Республики
2. Соблюдение требований по защите прав инвесторов
3. Ведение учёта и отчётности в установленном порядке

М.П.
    `
  },
  {
    id: 'registration',
    title: 'Свидетельство о государственной регистрации',
    icon: <FileText size={24} />,
    content: `
СВИДЕТЕЛЬСТВО
о государственной регистрации юридического лица

Настоящим подтверждается, что:

Полное наименование: Общество с ограниченной ответственностью «ФВА Финанс»
Сокращённое наименование: ОсОО «ФВА Финанс»

зарегистрировано в Едином государственном реестре юридических лиц, 
филиалов и представительств Кыргызской Республики

Регистрационный номер: 150744-3301-000
Дата регистрации: 2015 год

ИНН: 01111201510129
ОКПО: 29284076

Юридический адрес:
720001, Кыргызская Республика, г. Бишкек, 
Первомайский район, ул. Токтогула, 87A

Фактический адрес:
720044, Кыргызская Республика, г. Бишкек, 
Ленинский район, ул. Толомуша Океева, 39/5, кв. 27

Руководитель: Уткина Екатерина Алексеевна

Орган, осуществивший регистрацию:
Министерство юстиции Кыргызской Республики

М.П.
    `
  },
  {
    id: 'b2b-terms',
    title: 'Договор оказания услуг (B2B)',
    icon: <Briefcase size={24} />,
    content: `
ДОГОВОР ОКАЗАНИЯ УСЛУГ
для юридических лиц и индивидуальных предпринимателей

(Публичная оферта)
Редакция от 01.01.2024

ОсОО «ФВА Финанс», именуемое в дальнейшем «Исполнитель», в лице 
Директора Уткиной Е.А., действующей на основании Устава, предлагает 
юридическим лицам и индивидуальным предпринимателям (далее - «Заказчик») 
заключить настоящий Договор на следующих условиях:

1. ПРЕДМЕТ ДОГОВОРА

1.1. Исполнитель обязуется оказывать Заказчику услуги:
- Услуги по обмену валют (KGS, USD, EUR, RUB, KZT, MDL)
- Услуги по управлению мультивалютными счетами
- Консультационные услуги в сфере валютных операций
- Доступ к платформе PolyTech PRO

1.2. Заказчик обязуется оплачивать услуги в соответствии с тарифами Исполнителя.

2. ПОРЯДОК ЗАКЛЮЧЕНИЯ ДОГОВОРА

2.1. Договор считается заключённым с момента:
- Регистрации Заказчика в системе PolyTech PRO
- Прохождения верификации компании
- Акцептации настоящей оферты (первая операция в системе)

2.2. Акцепт оферты означает полное и безоговорочное принятие 
всех условий настоящего Договора.

3. ТРЕБОВАНИЯ К ЗАКАЗЧИКУ

3.1. Для регистрации Заказчик обязан предоставить:
- Свидетельство о государственной регистрации
- ИНН (идентификационный налоговый номер)
- Устав (для юридических лиц)
- Документ, подтверждающий полномочия представителя
- Банковские реквизиты

3.2. Заказчик гарантирует достоверность предоставленных сведений.

4. ТАРИФЫ И ОПЛАТА

4.1. Комиссия за обмен валют: от 0.5% до 1.5% в зависимости от объёма
4.2. Минимальная сумма операции: 10 000 KGS / 100 USD / 10 000 RUB
4.3. Корпоративные тарифы согласовываются индивидуально

4.4. Скидки для корпоративных клиентов:
- Оборот от 100 000 USD/месяц: -20% к комиссии
- Оборот от 500 000 USD/месяц: -40% к комиссии
- Оборот от 1 000 000 USD/месяц: индивидуальные условия

5. ПРАВА И ОБЯЗАННОСТИ СТОРОН

5.1. Исполнитель обязуется:
- Предоставлять услуги качественно и своевременно
- Обеспечивать безопасность операций
- Соблюдать конфиденциальность информации
- Предоставлять отчётность по операциям

5.2. Заказчик обязуется:
- Соблюдать условия настоящего Договора
- Предоставлять достоверную информацию
- Своевременно оплачивать услуги
- Соблюдать требования законодательства

6. ОТВЕТСТВЕННОСТЬ СТОРОН

6.1. За неисполнение обязательств стороны несут ответственность 
в соответствии с законодательством Кыргызской Республики.

6.2. Исполнитель не несёт ответственности за:
- Убытки, вызванные изменением курсов валют
- Задержки по вине банков и платёжных систем
- Блокировку операций по требованию государственных органов

7. СРОК ДЕЙСТВИЯ И РАСТОРЖЕНИЕ

7.1. Договор действует бессрочно с момента заключения.

7.2. Любая сторона может расторгнуть Договор, уведомив другую 
сторону за 30 календарных дней.

7.3. При расторжении Договора:
- Все незавершённые операции подлежат завершению
- Остатки на счетах возвращаются Заказчику
- Финансовые обязательства сохраняют силу

8. РАЗРЕШЕНИЕ СПОРОВ

8.1. Споры разрешаются путём переговоров.
8.2. При недостижении согласия - в судебном порядке 
по месту нахождения Исполнителя.

Реквизиты Исполнителя:
ОсОО «ФВА Финанс»
ИНН: 01111201510129
Юр. адрес: г. Бишкек, ул. Токтогула, 87A
Email: support@polytechex.com
Тел.: +996 507 210 992

Дата публикации: 01.01.2024
Директор: Уткина Е.А.
    `
  },
  {
    id: 'aml-b2b',
    title: 'Политика AML/KYC для юридических лиц',
    icon: <Shield size={24} />,
    content: `
ПОЛИТИКА
противодействия легализации (отмыванию) доходов, 
полученных преступным путём, и финансированию терроризма
для корпоративных клиентов (B2B)

ОсОО «ФВА Финанс»
Редакция от 01.01.2024

1. ОБЩИЕ ПОЛОЖЕНИЯ

1.1. Настоящая Политика разработана в соответствии с:
- Законом КР "О противодействии финансированию терроризма и легализации 
  (отмыванию) доходов, полученных преступным путём"
- Законом КР "О виртуальных активах"
- Рекомендациями ФАТФ (FATF)
- Типологиями ЕАГ

1.2. Политика распространяется на все юридические лица и индивидуальных 
предпринимателей, использующих платформу PolyTech PRO.

2. ИДЕНТИФИКАЦИЯ КЛИЕНТОВ-ЮРИДИЧЕСКИХ ЛИЦ (KYC/KYB)

2.1. Обязательные документы для верификации:
- Свидетельство о государственной регистрации
- Учредительные документы (Устав)
- ИНН компании
- Документы на руководителя и бенефициарных владельцев
- Выписка из реестра юридических лиц (не старше 30 дней)
- Лицензии (при необходимости)

2.2. Идентификация бенефициарных владельцев:
- Установление лиц, владеющих более 25% компании
- Идентификация конечных бенефициаров (UBO)
- Проверка цепочки владения

2.3. Проверка Политически Значимых Лиц (PEP):
- Руководители компании
- Учредители и бенефициарные владельцы
- Лица, имеющие право подписи

3. ПРОВЕРКА ПО САНКЦИОННЫМ СПИСКАМ

3.1. Все клиенты и их бенефициары проверяются по:
- Сводному санкционному списку КР (fiu.gov.kg)
- Сводному санкционному списку СБ ООН
- Национальным спискам розыска

3.2. Проверка производится:
- При регистрации клиента
- При изменении данных клиента
- Ежедневно для всей базы клиентов (автоматически)

3.3. При выявлении совпадения:
- Операции приостанавливаются
- Информация передаётся в Финансовую разведку КР
- Клиент уведомляется в установленном порядке

4. МОНИТОРИНГ ОПЕРАЦИЙ

4.1. Критерии подозрительных операций:
- Операции на сумму свыше 1 000 000 сом
- Частые операции дробления
- Операции с высокорисковыми юрисдикциями
- Несоответствие операций заявленной деятельности
- Необъяснимые источники средств

4.2. Порог обязательного контроля:
- Операции на сумму от 1 000 000 сом
- Операции с наличными от 500 000 сом

5. ВНУТРЕННИЙ КОНТРОЛЬ

5.1. Назначен Ответственный сотрудник по AML/KYC (Compliance Officer)

5.2. Проводится:
- Ежегодное обучение персонала
- Внутренний аудит AML-процедур
- Актуализация риск-матрицы

6. ХРАНЕНИЕ ДОКУМЕНТОВ

6.1. Срок хранения документов и данных операций: не менее 5 лет 
после завершения деловых отношений.

7. КОНТАКТЫ

Ответственный сотрудник по AML/KYC: support@polytechex.com
Телефон: +996 507 210 992

Дата утверждения: 01.01.2024
Директор: Уткина Е.А.
    `
  },
  {
    id: 'privacy-b2b',
    title: 'Политика конфиденциальности (B2B)',
    icon: <Lock size={24} />,
    content: `
ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ
для корпоративных клиентов платформы PolyTech PRO

Редакция от 01.01.2024

1. ОБЩИЕ ПОЛОЖЕНИЯ

1.1. Настоящая Политика определяет порядок обработки и защиты 
данных юридических лиц и индивидуальных предпринимателей.

1.2. Оператор персональных данных: ОсОО «ФВА Финанс»
     ИНН: 01111201510129

1.3. Правовая основа:
- Закон КР "О персональных данных"
- Закон КР "О защите информации"
- Закон КР "О коммерческой тайне"

2. СОБИРАЕМЫЕ ДАННЫЕ

2.1. Данные о юридическом лице:
- Наименование, ИНН, ОГРН/регистрационный номер
- Юридический и фактический адреса
- Банковские реквизиты
- Контактные данные

2.2. Данные о представителях и бенефициарах:
- ФИО, дата рождения
- Документы, удостоверяющие личность
- Контактные данные
- Сведения о должности и полномочиях

2.3. Операционные данные:
- История транзакций
- IP-адреса и данные устройств
- Логи действий в системе

3. ЦЕЛИ ОБРАБОТКИ

3.1. Данные обрабатываются для:
- Оказания услуг по договору
- Выполнения требований AML/KYC
- Выполнения требований налогового законодательства
- Обеспечения безопасности операций
- Улучшения качества услуг

4. ЗАЩИТА ДАННЫХ

4.1. Технические меры:
- Шифрование при передаче (TLS 1.3)
- Шифрование при хранении (AES-256)
- Двухфакторная аутентификация
- Логирование и мониторинг доступа

4.2. Организационные меры:
- Разграничение прав доступа
- Подписание NDA с сотрудниками
- Регулярный аудит безопасности
- План реагирования на инциденты

5. ПЕРЕДАЧА ДАННЫХ ТРЕТЬИМ ЛИЦАМ

5.1. Данные могут быть переданы:
- Банкам и платёжным системам (для проведения операций)
- Государственным органам (по законному требованию)
- Аудиторам (в рамках проверок)

5.2. Данные НЕ передаются:
- В коммерческих целях третьим лицам
- За пределы юрисдикции КР без законных оснований

6. СРОК ХРАНЕНИЯ

6.1. Данные хранятся в течение срока действия договора и 
не менее 5 лет после его прекращения.

7. ПРАВА КЛИЕНТА

7.1. Клиент имеет право:
- Получить информацию о своих данных
- Требовать исправления неточных данных
- Требовать удаления данных (с учётом законодательных требований)
- Отозвать согласие на обработку

8. КОНТАКТЫ

По вопросам защиты данных: support@polytechex.com
Телефон: +996 507 210 992

Дата публикации: 01.01.2024
ОсОО «ФВА Финанс»
    `
  },
  {
    id: 'refund-b2b',
    title: 'Политика возврата средств (B2B)',
    icon: <Scale size={24} />,
    content: `
ПОЛИТИКА ВОЗВРАТА СРЕДСТВ
для корпоративных клиентов

ОсОО «ФВА Финанс»
Редакция от 01.01.2024

1. ОБЩИЕ ПОЛОЖЕНИЯ

1.1. Настоящая Политика определяет условия и порядок возврата 
денежных средств корпоративным клиентам платформы PolyTech PRO.

1.2. Политика применяется к юридическим лицам и индивидуальным 
предпринимателям, зарегистрированным в системе.

2. УСЛОВИЯ ВОЗВРАТА

2.1. Возврат средств возможен в следующих случаях:
- Технический сбой при проведении операции
- Ошибочное зачисление средств
- Отмена операции до её исполнения
- Расторжение договора

2.2. Возврат НЕ осуществляется в случаях:
- Успешно завершённых операций обмена валют
- Нарушения условий Договора клиентом
- Блокировки по требованию государственных органов
- Операций с признаками мошенничества
- Истечения 60 дней с момента операции

3. ПОРЯДОК ПОДАЧИ ЗАЯВКИ

3.1. Для возврата средств необходимо:
- Направить официальное письмо на фирменном бланке компании
- Указать номер договора и реквизиты операции
- Описать причину возврата
- Приложить подтверждающие документы

3.2. Способы подачи заявки:
- Email: support@polytechex.com
- Почта: г. Бишкек, ул. Токтогула, 87A

4. СРОКИ РАССМОТРЕНИЯ И ВОЗВРАТА

4.1. Срок рассмотрения заявки: до 10 рабочих дней.

4.2. Срок возврата при положительном решении:
- Банковский перевод: 3-5 рабочих дней
- На валютный счёт в системе: 1 рабочий день

4.3. Валюта возврата:
- В той же валюте, в которой была совершена операция
- Конвертация по текущему курсу (при отсутствии исходной валюты)

5. КОМИССИИ

5.1. При возврате по вине Исполнителя: 0%
5.2. При возврате по инициативе Заказчика: 
     комиссия платёжной системы за перевод

6. ОСОБЫЕ СЛУЧАИ

6.1. При расторжении договора:
- Все незавершённые операции завершаются или отменяются
- Остатки средств возвращаются в течение 30 дней
- Комиссии за выполненные услуги не возвращаются

7. РАЗРЕШЕНИЕ СПОРОВ

7.1. Споры по возвратам разрешаются путём переговоров.

7.2. При недостижении согласия клиент может обратиться:
- В Государственную службу регулирования и надзора за 
  финансовым рынком при Кабинете Министров КР
- В Арбитражный суд Кыргызской Республики

Дата публикации: 01.01.2024
ОсОО «ФВА Финанс»
ИНН: 01111201510129
    `
  },
  {
    id: 'tariffs',
    title: 'Тарифы на услуги (B2B)',
    icon: <Building2 size={24} />,
    content: `
ТАРИФЫ НА УСЛУГИ
для корпоративных клиентов платформы PolyTech PRO

ОсОО «ФВА Финанс»
Действуют с 01.01.2024

1. ОБМЕН ВАЛЮТ

1.1. Стандартные тарифы:
┌─────────────────────────┬─────────────────┐
│ Направление             │ Комиссия        │
├─────────────────────────┼─────────────────┤
│ KGS ↔ USD              │ 1.0%            │
│ KGS ↔ EUR              │ 1.0%            │
│ KGS ↔ RUB              │ 0.8%            │
│ USD ↔ EUR              │ 0.5%            │
│ USD ↔ RUB              │ 1.0%            │
│ Прочие направления      │ 1.2%            │
└─────────────────────────┴─────────────────┘

1.2. Минимальная сумма операции: 10 000 KGS / 100 USD

2. СКИДКИ ПО ОБЪЁМУ

2.1. Месячный оборот:
┌─────────────────────────┬─────────────────┐
│ Оборот (USD эквивалент) │ Скидка          │
├─────────────────────────┼─────────────────┤
│ до 100 000             │ 0%              │
│ 100 000 - 500 000      │ -20%            │
│ 500 000 - 1 000 000    │ -40%            │
│ свыше 1 000 000        │ индивидуально   │
└─────────────────────────┴─────────────────┘

3. ДОПОЛНИТЕЛЬНЫЕ УСЛУГИ

3.1. Персональный менеджер:
- Оборот от 500 000 USD/мес: бесплатно
- Оборот менее 500 000 USD/мес: 500 USD/мес

3.2. API-интеграция: бесплатно для всех клиентов

3.3. Выписки и отчёты: бесплатно

4. БАНКОВСКИЕ ПЕРЕВОДЫ

4.1. Входящие переводы: бесплатно

4.2. Исходящие переводы:
- В пределах КР: 0.1% (мин. 50 KGS)
- Международные: комиссия банка-отправителя

5. ОСОБЫЕ УСЛОВИЯ

5.1. Курсы обмена фиксируются на момент подтверждения операции.

5.2. При операциях свыше 50 000 USD возможно согласование 
индивидуального курса.

5.3. Тарифы могут быть изменены с уведомлением за 30 дней.

Контакты для согласования индивидуальных условий:
Email: support@polytechex.com
Телефон: +996 507 210 992

Дата публикации: 01.01.2024
ОсОО «ФВА Финанс»
    `
  },
  {
    id: 'risk-disclosure',
    title: 'Раскрытие рисков',
    icon: <AlertTriangle size={24} />,
    content: `
УВЕДОМЛЕНИЕ О РИСКАХ
для корпоративных клиентов

ОсОО «ФВА Финанс»
Редакция от 01.01.2024

ВАЖНО: Перед использованием услуг платформы PolyTech PRO 
внимательно ознакомьтесь с настоящим уведомлением.

1. ВАЛЮТНЫЕ РИСКИ

1.1. Курсы валют подвержены колебаниям вследствие:
- Изменений процентных ставок центральных банков
- Геополитических событий
- Макроэкономических показателей
- Рыночных спекуляций

1.2. Клиент принимает на себя риск изменения курсов валют 
в период между заявкой и исполнением операции.

1.3. Исторические показатели не гарантируют будущих результатов.

2. ОПЕРАЦИОННЫЕ РИСКИ

2.1. Технические сбои:
- Возможны перебои в работе платформы
- Задержки в обработке операций
- Ошибки при передаче данных

2.2. Риски третьих лиц:
- Задержки в банках-корреспондентах
- Изменения в платёжных системах
- Блокировки по решению регуляторов

3. РЕГУЛЯТОРНЫЕ РИСКИ

3.1. Изменения в законодательстве:
- Введение новых требований валютного контроля
- Изменения в налогообложении
- Санкционные ограничения

3.2. Действия государственных органов:
- Блокировка операций по требованию уполномоченных органов
- Принудительное раскрытие информации
- Заморозка средств при расследованиях

4. РИСКИ КОНТРАГЕНТА

4.1. Компания прилагает все усилия для выполнения обязательств, 
однако не может гарантировать:
- Непрерывность оказания услуг
- Неизменность тарифов
- Сохранение всех функций платформы

5. ОГРАНИЧЕНИЕ ОТВЕТСТВЕННОСТИ

5.1. Компания НЕ несёт ответственности за:
- Убытки от изменения валютных курсов
- Косвенные или последующие убытки
- Упущенную выгоду
- Действия третьих лиц (банков, платёжных систем)
- Форс-мажорные обстоятельства

6. ПОДТВЕРЖДЕНИЕ КЛИЕНТА

6.1. Используя услуги платформы PolyTech PRO, клиент подтверждает:
- Ознакомление с настоящим уведомлением
- Понимание описанных рисков
- Готовность принять указанные риски
- Соответствие требованиям для работы с валютными операциями

7. РЕКОМЕНДАЦИИ

7.1. Рекомендуется:
- Диверсифицировать валютные позиции
- Устанавливать лимиты на операции
- Регулярно мониторить рыночную ситуацию
- Консультироваться с финансовыми специалистами

Дата публикации: 01.01.2024
ОсОО «ФВА Финанс»
    `
  },
  {
    id: 'extract',
    title: 'Реквизиты компании',
    icon: <FileText size={24} />,
    content: `
КАРТОЧКА ПРЕДПРИЯТИЯ
ОсОО «ФВА Финанс»

ОСНОВНЫЕ СВЕДЕНИЯ:

1. Полное наименование: 
   Общество с ограниченной ответственностью «ФВА Финанс»

2. Сокращённое наименование: ОсОО «ФВА Финанс»

3. Регистрационный номер: 150744-3301-000

4. ИНН: 01111201510129

5. ОКПО: 29284076

6. Юридический адрес:
   720001, Кыргызская Республика, г. Бишкек, 
   Первомайский район, ул. Токтогула, 87A

7. Фактический адрес:
   720044, Кыргызская Республика, г. Бишкек, 
   Ленинский район, ул. Толомуша Океева, 39/5, кв. 27

8. Руководитель: 
   Директор - Уткина Екатерина Алексеевна

9. Контакты:
   Телефон: +996 507 210 992
   Email: support@polytechex.com
   Сайт: fva-finance.com

БАНКОВСКИЕ РЕКВИЗИТЫ:

Банк 1: ОАО «Айыл Банк»
  Р/с (мультивалютный): 1350100020221904
  БИК: 135001

Банк 2: ОАО «ФинансКредитБанк»
  Р/с (мультивалютный): 1340000088397303
  БИК: 134001

Банк 3: Филиал ОАО «Керемет Банк»
  Р/с (мультивалютный): 1360370019060487
  БИК: 136001

ЛИЦЕНЗИИ:

1. Лицензия № 159 на брокерскую деятельность
   Дата выдачи: 16.03.2017, бессрочная

2. Лицензия № 160 на дилерскую деятельность
   Дата выдачи: 16.03.2017, бессрочная

Статус юридического лица: ДЕЙСТВУЮЩЕЕ
    `
  }
];

const B2BDocumentsPage = () => {
  const [selectedDoc, setSelectedDoc] = useState(null);

  if (selectedDoc) {
    const doc = documents.find(d => d.id === selectedDoc);
    return (
      <div className="min-h-screen" style={{ background: COLORS.bg }}>
        {/* Header */}
        <header className="bg-white border-b border-gray-100 sticky top-0 z-50">
          <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-4">
            <button 
              onClick={() => setSelectedDoc(null)}
              className="p-2 rounded-xl hover:bg-gray-100 transition"
              data-testid="back-button"
            >
              <ArrowLeft size={24} style={{ color: COLORS.dark }} />
            </button>
            <h1 className="font-semibold text-lg" style={{ color: COLORS.dark }}>
              {doc.title}
            </h1>
          </div>
        </header>

        {/* Document Content */}
        <div className="max-w-4xl mx-auto px-4 py-8">
          <div className="bg-white rounded-2xl shadow-sm p-6 md:p-8">
            <div className="flex items-center gap-4 mb-6 pb-6 border-b border-gray-100">
              <div 
                className="w-14 h-14 rounded-xl flex items-center justify-center"
                style={{ background: `${COLORS.primary}15`, color: COLORS.primary }}
              >
                {doc.icon}
              </div>
              <div>
                <h2 className="font-bold text-xl" style={{ color: COLORS.dark }}>{doc.title}</h2>
                <p className="text-sm" style={{ color: COLORS.gray }}>ОсОО «ФВА Финанс» • B2B</p>
              </div>
            </div>
            
            <pre 
              className="whitespace-pre-wrap font-sans text-sm leading-relaxed"
              style={{ color: COLORS.dark }}
            >
              {doc.content}
            </pre>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen" style={{ background: COLORS.bg }}>
      {/* Header */}
      <header className="bg-white border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <div className="flex items-center gap-3 mb-2">
            <div 
              className="w-12 h-12 rounded-xl flex items-center justify-center"
              style={{ background: COLORS.primary, color: 'white' }}
            >
              <Building2 size={24} />
            </div>
            <div>
              <h1 className="text-2xl font-bold" style={{ color: COLORS.dark }}>
                PolyTech PRO
              </h1>
              <p className="text-sm" style={{ color: COLORS.gray }}>
                Юридические документы для корпоративных клиентов
              </p>
            </div>
          </div>
        </div>
      </header>

      {/* Documents Grid */}
      <div className="max-w-4xl mx-auto px-4 py-6">
        <div className="grid gap-4">
          {documents.map((doc) => (
            <motion.button
              key={doc.id}
              onClick={() => setSelectedDoc(doc.id)}
              className="w-full bg-white rounded-xl p-4 flex items-center gap-4 text-left hover:shadow-md transition-shadow"
              whileHover={{ scale: 1.01 }}
              whileTap={{ scale: 0.99 }}
              data-testid={`doc-${doc.id}`}
            >
              <div 
                className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
                style={{ background: `${COLORS.primary}15`, color: COLORS.primary }}
              >
                {doc.icon}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold" style={{ color: COLORS.dark }}>
                  {doc.title}
                </h3>
                <p className="text-sm truncate" style={{ color: COLORS.gray }}>
                  Нажмите для просмотра
                </p>
              </div>
              <ArrowLeft 
                size={20} 
                className="rotate-180 flex-shrink-0" 
                style={{ color: COLORS.grayLight }} 
              />
            </motion.button>
          ))}
        </div>

        {/* Footer */}
        <div className="mt-8 text-center">
          <p className="text-sm" style={{ color: COLORS.gray }}>
            ОсОО «ФВА Финанс» • ИНН: 01111201510129
          </p>
          <p className="text-sm mt-1" style={{ color: COLORS.grayLight }}>
            г. Бишкек, ул. Токтогула, 87A • +996 507 210 992
          </p>
        </div>
      </div>
    </div>
  );
};

export default B2BDocumentsPage;
